/* Powr Labs · product-page behaviours: reviews "show more", add-on cross-sell. No dependencies. */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmtDate(d) {
    if (!d) return '';
    var dt = new Date(d);
    if (isNaN(dt.getTime())) return esc(d);
    return dt.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  }

  // Reviews: reveal more cards from embedded JSON
  var moreBtn = document.querySelector('[data-pl-reviews-more]');
  if (moreBtn) {
    var list = document.querySelector('[data-pl-reviews-list]');
    var tpl = document.querySelector('template[data-pl-reviews-card]');
    var jsonEl = document.querySelector('[data-pl-reviews-json]');
    var all = [];
    try { all = JSON.parse(jsonEl.textContent) || []; } catch (e) { all = []; }
    var offset = parseInt(moreBtn.getAttribute('data-offset'), 10) || 8;
    var step = parseInt(moreBtn.getAttribute('data-step'), 10) || 8;
    moreBtn.addEventListener('click', function () {
      var slice = all.slice(offset, offset + step);
      var frag = document.createDocumentFragment();
      slice.forEach(function (rv) {
        var card = document.createElement('article'); card.className = 'pl-review';
        var top = document.createElement('div'); top.className = 'pl-review__top';
        var stars = document.createElement('span'); stars.className = 'pl-stars'; stars.setAttribute('aria-label', (rv.r || 0) + ' out of 5 stars');
        var fill = document.createElement('span'); fill.className = 'pl-stars__fill'; fill.style.width = ((Number(rv.r) || 0) * 20) + '%'; stars.appendChild(fill); top.appendChild(stars);
        var name = document.createElement('span'); name.className = 'pl-review__name'; name.textContent = rv.n || 'Amazon customer'; top.appendChild(name);
        if (rv.v) { var ver = document.createElement('span'); ver.className = 'pl-review__verified'; ver.textContent = 'Verified purchase'; top.appendChild(ver); }
        if (rv.s) { var src = document.createElement('span'); src.className = 'pl-review__source'; src.textContent = 'on ' + rv.s; top.appendChild(src); }
        var date = document.createElement('span'); date.className = 'pl-review__date'; date.textContent = fmtDate(rv.d); top.appendChild(date);
        card.appendChild(top);
        if (rv.t) { var h = document.createElement('h3'); h.className = 'pl-review__title'; h.textContent = rv.t; card.appendChild(h); }
        var body = document.createElement('p'); body.className = 'pl-review__body';
        String(rv.b || '').split('\n').forEach(function (line, i) { if (i) body.appendChild(document.createElement('br')); body.appendChild(document.createTextNode(line)); });
        card.appendChild(body);
        if (rv.i && rv.i.length) {
          var imgs = document.createElement('div'); imgs.className = 'pl-review__imgs';
          rv.i.slice(0, 4).forEach(function (u) { var a = document.createElement('a'); a.href = u; a.target = '_blank'; a.rel = 'noopener nofollow'; var im = document.createElement('img'); im.src = u; im.loading = 'lazy'; im.width = 96; im.height = 96; im.alt = 'Customer photo from ' + (rv.n || 'a customer'); a.appendChild(im); imgs.appendChild(a); });
          card.appendChild(imgs);
        }
        frag.appendChild(card);
      });
      list.appendChild(frag);
      offset += step;
      var left = all.length - offset;
      if (left <= 0) { moreBtn.parentNode.removeChild(moreBtn); }
      else { moreBtn.textContent = 'Show more reviews (' + left + ' more)'; }
    });
  }

  // Product hero carousel: scroll-snap viewport + arrows + thumbnail rail
  var car = document.querySelector('[data-pl-carousel]');
  if (car) {
    var vp = car.querySelector('[data-pl-viewport]');
    var slides = Array.prototype.slice.call(car.querySelectorAll('[data-pl-slide]'));
    var thumbs = Array.prototype.slice.call(car.querySelectorAll('[data-pl-thumb]'));
    var cur = 0;
    function goTo(i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      vp.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function setActive(i) {
      if (i === cur) return;
      cur = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      var at = thumbs[i];
      if (at && at.scrollIntoView) { try { at.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } catch (e) {} }
      slides.forEach(function (s, k) { if (k !== i) { var v = s.querySelector('video'); if (v && !v.paused) v.pause(); } });
    }
    var prev = car.querySelector('[data-pl-prev]'), next = car.querySelector('[data-pl-next]');
    if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
    if (next) next.addEventListener('click', function () { goTo(cur + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-index'), 10) || 0); }); });
    var raf = null;
    vp.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var x = vp.scrollLeft, w = vp.clientWidth || 1;
        setActive(Math.round(x / w));
      });
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (e.target && /input|textarea|select/i.test(e.target.tagName)) return;
      if (e.key === 'ArrowLeft') goTo(cur - 1); else if (e.key === 'ArrowRight') goTo(cur + 1);
    });
  }

  // Open every product-page content link in a new tab (header, footer and cart actions excluded)
  (function () {
    var scope = document.querySelector('main, #MainContent, .main-content') || document.body;
    var anchors = scope.querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i], href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0 || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) continue;
      if (href.indexOf('/cart') === 0 || href.indexOf('/checkout') === 0 || a.closest('header, footer, .site-header, .site-footer, .cart-drawer, .drawer, .pl-addon')) continue;
      if (a.hasAttribute('data-product-thumb') || a.classList.contains('product__thumb') || a.hasAttribute('data-photoswipe-src') || a.closest('.product__thumbs, .product__photos, .photoswipe__image')) continue;
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', (a.getAttribute('rel') || '').replace('noopener', '').trim() + ' noopener');
    }
  })();

  // Hero form: add via AJAX and open the theme's cart drawer (falls back to the cart page)
  var heroForm = document.getElementById('pl-product-form');
  function plOpenCart() {
    try {
      if (window.jQuery && window.theme && window.theme.cart && document.getElementById('CartDrawer')) { window.jQuery('body').trigger('updateCart'); return true; }
    } catch (e) {}
    return false;
  }
  function plBumpCartCount() {
    try {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var b = document.querySelector('.cart-link__bubble');
        if (b) { b.textContent = cart.item_count; b.classList.add('cart-link__bubble--visible'); }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      });
    } catch (e) {}
  }
  if (heroForm) {
    heroForm.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = heroForm.querySelector('.pl-ph__cta');
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = '<span>Adding…</span>'; }
      var picked = heroForm.querySelector('[data-pl-bundle] input:checked');
      var bundleItems = picked ? JSON.parse(picked.getAttribute('data-items')) : null;
      var isBundle = bundleItems && picked.getAttribute('data-save') !== '0';
      var addReq = isBundle
        ? { method: 'POST', body: JSON.stringify({ items: bundleItems }), headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } }
        : { method: 'POST', body: new FormData(heroForm), headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
      fetch('/cart/add.js', addReq)
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          if (btn) { btn.innerHTML = '<span>Added ✓</span><span class="pl-ph__cta-price">View cart →</span>'; btn.disabled = false; btn.classList.add('is-added'); }
          var opened = plOpenCart();
          if (!opened) { plBumpCartCount(); btn.onclick = function (e) { e.preventDefault(); window.location.href = '/cart'; }; }
          else { setTimeout(function () { btn.innerHTML = label; btn.classList.remove('is-added'); }, 2500); }
        }, function () {
          if (btn) { btn.innerHTML = label; btn.disabled = false; }
          // A plain form post can only add the single product, so never use it for a bundle
          if (isBundle) { var err = heroForm.querySelector('[data-pl-bundle-error]'); if (err) err.hidden = false; return; }
          heroForm.submit();
        });
    });

    // Bundle picker: keep the price, button and express checkout in step with the chosen option
    var bundle = heroForm.querySelector('[data-pl-bundle]');
    if (bundle) {
      var nowEl = document.querySelector('.pl-ph__price-now');
      var ctaEl = heroForm.querySelector('.pl-ph__cta-price');
      var dynEl = heroForm.querySelector('.pl-ph__dynamic');
      var compareEl = document.querySelector('.pl-ph__price-compare');
      var pillEl = document.querySelector('.pl-ph__price-pill');
      var syncBundle = function () {
        var sel = bundle.querySelector('input:checked');
        if (!sel) return;
        var price = sel.getAttribute('data-price');
        var isBundle = sel.getAttribute('data-save') !== '0';
        if (nowEl) nowEl.textContent = price;
        if (ctaEl) ctaEl.textContent = price;
        if (dynEl) dynEl.hidden = isBundle;
        // The compare-at price and % off describe one unit, so they don't apply to a bundle total
        if (compareEl) compareEl.hidden = isBundle;
        if (pillEl) pillEl.hidden = isBundle;
      };
      bundle.addEventListener('change', syncBundle);
      syncBundle();
    }
  }

  // Add-on: add the companion product to the cart
  var addBtn = document.querySelector('[data-pl-addon-add]');
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var id = addBtn.getAttribute('data-variant-id');
      addBtn.disabled = true; addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          addBtn.textContent = 'Added ✓'; addBtn.classList.add('is-added');
          var drawerLink = document.querySelector('a[href="/cart"].site-nav__link, .js-drawer-open-cart, [data-cart-trigger]');
          if (!plOpenCart()) {
            var count = document.querySelector('.cart-link__bubble');
            if (count) { count.classList.add('cart-link__bubble--visible'); }
          }
          setTimeout(function () { addBtn.disabled = false; }, 1500);
        })
        .catch(function () { addBtn.disabled = false; addBtn.textContent = 'Add'; window.location.href = '/cart'; });
    });
  }
})();
